export default "__VITE_PUBLIC_ASSET__1bb810c2__"